import { useEffect, useState } from "react";
import { iAxios } from '../../lib/utils';
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { Spinner } from "../common/Helper";
import classNames from "classnames";
import Icon from "../ds/Icon";
import { STATUS_CHART_COLORS as CLRS, DATA_COLORS, chartTooltip } from '../../lib/chartTheme';


const CheckboxItem = ({ el, onChange }) => {
    return <button type="button"
        className={classNames('tag-chip', { 'is-active': el.selected })}
        onClick={() => onChange(!el.selected, el)}>
        {el.name}
    </button>;
}


const getRunStatus = async (projectId, sprintId) => {

    const jql = `project=${projectId} AND SPRINT=${sprintId} AND issueType=TestCaseRun and issueLinkType is not empty ORDER BY updated DESC`;
    let page = 0;
    let issueList = [];
    while (true) {
        const result = await iAxios.get('/api/v1/jira', {
            params: {
                path: `/rest/api/3/search?startAt=${page * 50}&jql=${encodeURIComponent(jql)}`
            }
        });
        page++;
        if (result.data) {
            issueList = issueList.concat(result.data.issues);
            if (result.data.issues.length < 50) {
                break;
            }
        }
    }
    return issueList;
}

export const StatusWidget = ({ projectId, sprintId, closePopup }) => {

    const [list, setList] = useState([]);
    const [mode, setMode] = useState('');
    const [versions, setVersions] = useState([]);
    const [labels, setLabels] = useState([]);
    const [components, setComponents] = useState([]);
    const [assignees, setAssignees] = useState([]);
    const [data, setData] = useState([]);

    const [totalCount, setTotal] = useState(0);
    // const [jql, se/tJql] = useState()


    useEffect(() => {

        const iLabels = [];
        const iComponents = [];
        const iVersions = [];
        const iAssignees = [];

        const iData = list.reduce((agg, ri) => {
            const item = agg.find(a => a.name === ri.fields.status.name);

            ri.fields.labels.forEach(lab => {
                if (!iLabels.find(l => l.id === lab)) {
                    iLabels.push({
                        id: lab,
                        name: lab,
                        selected: true
                    });
                }
            });

            ri.fields.fixVersions.forEach(ver => {
                if (!iVersions.find(v => v.id === ver.id)) {
                    iVersions.push({
                        id: ver.id,
                        name: ver.name,
                        selected: true
                    });
                }
            });

            ri.fields.components.forEach(comp => {
                if (!iComponents.find(c => c.id === comp.id)) {
                    iComponents.push({
                        id: comp.id,
                        name: comp.name,
                        selected: true
                    });
                }
            });



            if (ri.fields.assignee && !iAssignees.find(a => a.id === ri.fields?.assignee?.accountId)) {
                iAssignees.push({
                    id: ri.fields.assignee.accountId,
                    selected: true,
                    name: ri.fields.assignee.displayName
                })
            }




            if (!item) {
                agg.push({
                    name: ri.fields.status.name,
                    value: 1
                })
            } else {
                item.value += 1;
            }
            return agg;
        }, []);

        iVersions.push({
            id: 'empty',
            name: 'EMPTY',
            selected: true,
        });
        iComponents.push({
            id: 'empty',
            name: 'EMPTY',
            selected: true,
        });
        iLabels.push({
            id: 'empty',
            selected: true,
            name: 'EMPTY'
        });
        iAssignees.push({
            id: 'empty',
            selected: true,
            name: 'None'
        })

        setAssignees(iAssignees);
        setData(iData);
        setVersions(iVersions);
        setComponents(iComponents);
        setLabels(iLabels)
    }, [list]);

    useEffect(() => {
        let total = 0;

        const iData = list.filter(item => {
            const fields = item.fields;
            const flag1 = labels.filter(l => l.selected).some(l => {

                if (l.id === 'empty') {
                    return fields.labels.length === 0;
                }
                return fields.labels.some(lab => lab === l.name);
            });

            const flag2 = versions.filter(v => v.selected).some(v => {
                if (v.id === 'empty') {
                    return fields.fixVersions.length === 0;
                }
                return fields.fixVersions.some(va => v.id === va.id)
            });
            const flag3 = components.filter(c => c.selected).some(c => {
                if (c.id === 'empty') {
                    return fields.components.length === 0;
                }
                return fields.components.some(comp => {
                    return c.id === comp.id
                });
            });

            const flag4 = assignees.filter(a => a.selected).some(a => {
                if (a.id === 'empty') {
                    return !fields.assignee;
                }
                if (!fields.assignee) {
                    return false;
                }
                return fields.assignee.accountId === a.id;
            });
            return flag1 && flag2 && flag3 && flag4;
        }).reduce((agg, ri) => {
            const item = agg.find(a => a.name === ri.fields.status.name);
            total++;
            if (!item) {
                agg.push({
                    name: ri.fields.status.name,
                    value: 1
                })
            } else {
                item.value += 1;
            }
            return agg;
        }, []);
        setTotal(total);
        setData(iData.sort((a, b) => a.name.localeCompare(b.name)));

    }, [labels, components, versions, assignees, list])

    useEffect(() => {
        const process = async () => {
            setMode('loading')
            const status = await getRunStatus(projectId, sprintId);
            setList(status);
            setMode('loaded')
        }
        process();
    }, [projectId, sprintId])

    const nameMap = name => {
        return name === 'EMPTY' ? name : `"${name}"`;
    }
    const getUrl = (status) => {
        //`project = ${projectId} AND Sprint = ${sprintId} ORDER BY created DESC`
        const jql = `project = ${projectId} AND Sprint = ${sprintId} AND  \
         fixVersion in (${versions.filter(item => item.selected).map(v => nameMap(v.name)).join(',')}) AND \
         component in (${components.filter(item => item.selected).map(c => nameMap(c.name)).join(',')}) AND \
         assignee in (${assignees.filter(item => item.selected).map(a => a.id)}) AND \
         labels in (${labels.filter(item => item.selected).map(l => nameMap(l.name)).join(',')}) and status=${nameMap(status)} ORDER BY created DESC`;

        return `https://ntuclink.atlassian.net/issues/?jql=${encodeURIComponent(jql)}`;
    }

    const changeLabel = (val, el) => {
        el.selected = val;
        setLabels(labels.concat([]));
    }

    const changeVersion = (val, el) => {
        el.selected = val;
        setVersions(versions.concat([]));
    }
    const changeComp = (val, el) => {
        el.selected = val;
        setComponents(components.concat([]));
    }
    const changeAssignee = (val, el) => {
        el.selected = val;
        setAssignees(assignees.concat([]));
    }

    const toggleComps = () => {
        const next = !components[0].selected
        setComponents(components.map(item => {
            item.selected = next;
            return item;
        }));
    }

    const toggleLabels = () => {
        const next = !labels[0].selected
        setLabels(labels.map(item => {
            item.selected = next
            return item;
        }));
    }
    const toggleVersions = () => {
        const next = !versions[0].selected;
        setVersions(versions.map(item => {
            item.selected = next;
            return item;
        }));
    }

    const toggleAssignee = () => {
        const next = !assignees[0].selected;
        setAssignees(assignees.map(item => {
            item.selected = next;
            return item;
        }));
    }
    const charts = [
        <Pie
            key="outer"
            data={data}
            innerRadius="40%"
            outerRadius="70%"
            dataKey="value"
            cy="50%"
            cx="50%" >
            {data.map((entry, index) => {
                const key = entry.name.toUpperCase();
                const clr = CLRS[key] || DATA_COLORS[index % DATA_COLORS.length];
                return <Cell key={entry.name} fill={clr} />
            })
            }
        </Pie>,

        <Tooltip key="tooltip" {...chartTooltip} />,
        <Legend iconSize={10} width={120} height={140} layout='vertical' verticalAlign='middle' align="right" />
    ];

    const FilterSection = ({ title, onToggle, items, onChange }) => (
        <div style={{ marginBottom: 'var(--ds-space-4)' }}>
            <button type="button" className="ds-btn is-ghost is-sm" onClick={onToggle} style={{ marginBottom: 'var(--ds-space-2)' }}>{title} · toggle all</button>
            <div className="tag-cloud">
                {items.map(item => <CheckboxItem key={item.id} el={item} onChange={onChange} />)}
            </div>
        </div>
    );

    return <div className="ds-scope ds-modal is-open" onMouseDown={(e) => { if (e.target === e.currentTarget) closePopup(e); }}>
        <div className="ds-modal__dialog ds-modal--wide" role="dialog" aria-modal="true" aria-label="Test run status" style={{ maxWidth: '900px' }}>
            <button type="button" className="ds-btn is-ghost is-icon ds-modal__close" aria-label="Close" onClick={closePopup}>
                <Icon name="close" />
            </button>
            <h3 style={{ marginBottom: 'var(--ds-space-4)' }}>Test Run Status {list.length > 0 && <span className="ds-panel__sub">Total {list.length}</span>}</h3>

            <div className="split-main">
                <div>
                    {mode === 'loaded' && <ResponsiveContainer width="100%" height={360}>
                        <PieChart>{charts}</PieChart>
                    </ResponsiveContainer>}
                    {mode === 'loading' && <Spinner />}
                </div>
                <div className="ds-table-wrap">
                    <table className="ds-table">
                        <tbody>
                            {data.map(item => (
                                <tr key={item.name}>
                                    <td><a target="_blank" rel="noreferrer" href={getUrl(item.name)}>{item.name}</a></td>
                                    <td className="ds-nums">{item.value}</td>
                                </tr>
                            ))}
                            {totalCount > 0 && <tr><td><b>Total</b></td><td className="ds-nums"><b>{totalCount}</b></td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>

            {mode === 'loaded' && <div style={{ marginTop: 'var(--ds-space-5)' }}>
                <FilterSection title="Labels" onToggle={toggleLabels} items={labels} onChange={changeLabel} />
                <FilterSection title="Versions" onToggle={toggleVersions} items={versions} onChange={changeVersion} />
                <FilterSection title="Assignees" onToggle={toggleAssignee} items={assignees} onChange={changeAssignee} />
                <FilterSection title="Components" onToggle={toggleComps} items={components} onChange={changeComp} />
            </div>}
        </div>
    </div>;
}